import React, {useContext, useEffect, useState} from "react";

import {connect, useDispatch} from "react-redux";
import {getTrainingDataList, getTrainingDataFile, createModel, getModels} from "../../util/redux/asyncActions";
import {Select, Form, Input, Button, Alert, Spin, Typography} from 'antd';
import ManyosSpinner from "../../ManyosSpinner/ManyosSpinner";
import {AuthContext} from "../../Auth/AuthProvider";
import {RocketOutlined} from "@ant-design/icons";

const {Text} = Typography;
const select = state => {
    const files = state.request.files
    const loading = state.request.loading
    const models = state.request.models
    const error = state.request.error
    return {
        files,
        loading,
        models,
        error
    }
}

function CreateModel(props) {

    const {files, loading, models, error} = props
    const [isTraining, setIsTraining] = useState(false)
    const [trainSuccess, setTrainSuccess] = useState(false)
    const [filename, setFilename] = useState()
    const dispatch = useDispatch()
    const userManager = useContext(AuthContext);
    const [baseModels, setBaseModels] = useState(
    )
    useEffect(() => {
        dispatch(getTrainingDataList({userManager}))
        dispatch(getModels({userManager}))
    }, [])
    useEffect(() => {

        if (models) {
            setBaseModels(models.filter(model => model.type == "default").map(model => model.model))
        }


    }, [models])

    const [baseModel, setBaseModel] = useState()
    const [language, setLanguage] = useState()
    const [modelName, setModelName] = useState()
    const handleFileSelect = (file) => {
        setFilename(file)
        dispatch(getTrainingDataFile({file, userManager}))
    }
    const handleModelNameChange = (e) => {
        setModelName(e.target.value)

    }
    const handleSelectBaseModel = (model) => {
        const definition = models.find(m => m.model === model)
        setBaseModel(model)
        setLanguage(definition.lang)

    }


    return (
        <ManyosSpinner spinning={loading}>
            <div style={{maxWidth: 600, margin: "0 auto", padding: "8px 0 24px"}}>
                <div className="sc-panel">
                    <div className="sc-panel-cap">Create model — train on a data file</div>
                <Form layout="vertical">
                    {(files) && (
                        <Form.Item label="Training Data File">
                            <Select
                                value={filename}
                                onSelect={handleFileSelect}
                                placeholder="Select a training data file..."
                                options={files.map((file, i) => {
                                    const f = typeof file === "string" ? {name: file} : file;
                                    return {
                                        key: `file-${i}`,
                                        value: f.name,
                                        label: f.modified
                                            ? `${f.name}  ·  ${new Date(f.modified * 1000).toLocaleString([], {day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit"})}`
                                            : f.name
                                    };
                                })}
                            />
                        </Form.Item>
                    )}
                    {baseModels && (
                        <Form.Item label="Base Model">
                            <Select
                                value={baseModel}
                                onSelect={handleSelectBaseModel}
                                placeholder="Select a base model..."
                                options={baseModels.map((model, i) => ({
                                    key: `model-${i}`,
                                    value: model,
                                    label: model
                                }))}
                            />
                        </Form.Item>
                    )}

                    <Form.Item label="Model Name">
                        <Input
                            placeholder="Enter a name for the new model"
                            value={modelName}
                            onChange={handleModelNameChange}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            size="large"
                            block
                            icon={<RocketOutlined/>}
                            disabled={!modelName || !filename || !baseModel || loading}
                            onClick={() => {
                                setIsTraining(true)
                                setTrainSuccess(false)
                                dispatch(createModel({modelName, filename, baseModel, language, userManager}))
                                    .then((result) => {
                                        setIsTraining(false)
                                        if (!result.error) {
                                            setTrainSuccess(true)
                                        }
                                    })
                                    .catch(() => setIsTraining(false))
                            }}
                            aria-label="Create model"
                        >
                            Create Model
                        </Button>
                    </Form.Item>

                    {isTraining && (
                        <Alert
                            message="Training in progress..."
                            description="This may take several minutes. Please don't close this window."
                            type="info"
                            showIcon
                            icon={<Spin size="small"/>}
                            style={{marginBottom: 16}}
                        />
                    )}

                    {trainSuccess && (
                        <Alert
                            message="Model Created Successfully"
                            description={`Model "${modelName}" is now available for testing.`}
                            type="success"
                            showIcon
                            closable
                            onClose={() => setTrainSuccess(false)}
                            style={{marginBottom: 16}}
                        />
                    )}

                    {error && !isTraining && (
                        <Alert
                            message="Error"
                            description={error}
                            type="error"
                            showIcon
                            style={{marginBottom: 16}}
                        />
                    )}
                </Form>
                </div>
            </div>
        </ManyosSpinner>
    )
}

export default connect(select)(CreateModel)
